import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Column } from '@tanstack/react-table';

interface ISortingProps<T> {
  header: string;
  column: Column<T, unknown>;
}

const Sorting = <T,>({ header, column }: ISortingProps<T>): JSX.Element => {
  const isSorted = column.getIsSorted();

  return (
    <div
      className="flex items-center gap-x-2 cursor-pointer"
      onClick={column.getToggleSortingHandler()}>
      <span>{header}</span>
      <div className="flex flex-col">
        {isSorted === 'asc' && (
          <ChevronUpIcon className="w-3 stroke-2 text-[rgba(68,81,102,0.8)]" />
        )}
        {isSorted === 'desc' && (
          <ChevronDownIcon className="w-3 stroke-2 text-[rgba(68,81,102,0.8)]" />
        )}
        {!isSorted && (
          <div className="flex flex-col">
            <ChevronUpIcon className="w-3 stroke-2 text-[rgba(68,81,102,0.5)]" />
            <ChevronDownIcon className="w-3 stroke-2 text-[rgba(68,81,102,0.5)]" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Sorting;
